import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AlertController, LoadingController, ModalController, NavController } from '@ionic/angular';
import { ToastController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { DialogComponent, DialogData } from '../componentes/dialog/dialog.component';
import { ExpandirImagenComponent } from '../componentes/expandir-imagen/expandir-imagen.component';
import { ConexionService } from './conexion.service'
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class UtilidadesService {
  private loading: any;
  isLoading = false;
  datePipe = new DatePipe("en-US")
  UltimoMensaje = ""

  constructor(private alertController: AlertController, private modalController: ModalController,
    private loadingController: LoadingController, private nav: NavController, private route: Router,
    private dialog: MatDialog, private toastController: ToastController) { }

  async Alerta(message: string, buttonText = "Aceptar", header?: string) {
    if(!message || this.UltimoMensaje == message || message == "'Datos'") {return 0;}
    this.UltimoMensaje = message
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header,
      message,
      buttons: [buttonText]
    });

    await alert.present();
    setTimeout(() => {
      this.UltimoMensaje = ""
    }, 1600);
    const { role } = await alert.onDidDismiss();
  }

  private subExpandirImagen = new Subject()
  public subExpandirImagen$ = this.subExpandirImagen.asObservable()
  nexSubExpandirImagen(dato){
    this.subExpandirImagen.next(dato)
  }

  async ExpandirImagen(imagen, OtrasImagenes=[], indice=0) {
    const modal = await this.modalController.create({
      component: ExpandirImagenComponent,
      cssClass: 'ExtenderImagen',
      componentProps: {
        Imagen: imagen,
        OtrasImagenes,
        indice
      }, 
    });

    modal.onDidDismiss().then(info => {
      if(info){
        this.nexSubExpandirImagen(info)
      }
    })
    return modal.present();

  }

  async Loading(m, tiempo=5000, mostrarMensaje=false) {

    setTimeout(() => {
      this.isLoading = true;
      let body = document.getElementById("cuerpo")
      let div = document.createElement("div")
      div.classList.add("cargando")
      div.id = "cargador"
      body.appendChild(div)
    div.innerHTML = div.innerHTML + " " + '<div class="cargando"></div>'
    }, 100);

    // return 
    // let message = ""
    // if(mostrarMensaje){
    //   message=m
    // }
    // this.isLoading = true;
    // this.loading = await this.loadingController.create({
    //   cssClass: 'my-custom-class',
    //   message: "",
    //   duration: tiempo,
    //   "spinner": "lines",
    //   }).then(a => {
    //   a.present().then(() => {
    //     if (!this.isLoading) {
         
    //     }
    //   });
    // });
  }

  async CerrarLoading() {
    
        setTimeout(() => {
          this.isLoading = false;
          let body = document.getElementById("cuerpo")
          let div = document.getElementById("cargador")
          if(div){
            body.removeChild(div)
          }
        }, 200);
      

    // setTimeout(() => {
    //   if(this.isLoading){
    //     this.loadingController.dismiss().then(() => {});
    //   }
    //   this.isLoading = false;
         
    // }, 500);
  }


  FormatoFecha(fecha:any=new Date(), formato="yyyy-MM-dd HH:mm", zone="GMT"){
    return this.datePipe.transform(fecha, formato, zone)
  }


  Depuracion(mensaje, tipo, codigo){
    let depurar:boolean = false;

    if(atob(localStorage.getItem(btoa("Depurar"))) == "1"){
      depurar=true
    }

    if(depurar){
      if(tipo=="console"){
        console.log(mensaje)
      }else{
       this.Alerta(mensaje)
      }
    }else{
      if(tipo!="console"){
        if(codigo=="ERR003"){
          this.Alerta("Ha ocurrido un error")
        }else{
          this.Alerta(mensaje)
        }
      }
    }
  }


  async Toast(message, tiempo = 3000, icon= 'information-circle', color="light", buttons=[], position: any= "top") {
    const toast = await this.toastController.create({
      message,
      duration: tiempo,
      position: position,
      icon,
      color,
      buttons
    });
    return toast.present();
  }

  private OnSesion = new Subject();
  public onSesion$ = this.OnSesion.asObservable()

  public nextOnSesion(val) {
    this.OnSesion.next(val)
  }

  private OnEliminado = new Subject();
  public onEliminado$ = this.OnSesion.asObservable()

  public nextOnEliminado(val) {
    this.OnEliminado.next(val)
  }

  private tetminoSubida = new Subject();
  public tetminoSubida$ = this.tetminoSubida.asObservable()

  public nextOntetminoSubida(val) {
    this.tetminoSubida.next(val)
  }

  Nav(ruta: string) {
    // location.href = location.origin + "/#"+ruta
    this.route.navigate([ruta])
    // this.nav.navigateForward(ruta)
  }

  NavBack() {
    this.nav.back()
  }


  Reemplazar(value: string, reemplazar:string, con:string){
    for(let i=0; i<50; i++){
      value = value.replace(reemplazar, con)
    }

  return value
  }

  ValidarUser(err) {
    if (err.error.Codigo == "US000") {
      localStorage.clear()
      setTimeout(() => {
        this.Alerta(err.error.Mensaje)
      }, 300);
      this.nav.navigateForward("/login")
      this.nextOnSesion(false)
    }
  }


  VerificarPrivilegio(PrivRequerido: string): boolean {
    if (PrivRequerido == "") return true;

    if ((localStorage.getItem((btoa("Privilegios"))))) {
      let Privilegios: { Privilegio: string, Id: number, IdUsuarioTipo: number }[] = JSON.parse(atob(localStorage.getItem((btoa("Privilegios"))))) || []
      for (let i of Privilegios) {
        if (i.Privilegio == PrivRequerido) {
          return true;
        }
      }
    }

    return false;
  }


  Compartir(titulo, texto, link) {
    if (navigator.share) {
      navigator.share({
        title: titulo,
        text: texto,
        url: link,
      })
        .then(() => { this.Alerta("Se ha compartido exitosamente") })
        .catch((error) => {
          this.Alerta("No se ha podido compartir"); console.log('Error sharing', error)
          alert(error)
        });
    } else {
      this.Alerta("Tu sistema no es compatible para compartir")
    }
  }



  MostrarMensaje(data: DialogData): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '250px',
      data,
    });

   
  }


  private SubirArchivos = new Subject();
  public SubirArchivos$ = this.SubirArchivos.asObservable()

  public nextSubirArchivos(val) {
    this.SubirArchivos.next(val)
  }

  private ocultarMenu = new Subject();
  public ocultarMenu$ = this.ocultarMenu.asObservable()

  public nextocultarMenu(val) {
    this.ocultarMenu.next(val)
  }


  private stepper = new Subject();
  public stepper$ = this.stepper.asObservable()

  public nextStepper(val) {
    this.stepper.next(val)
  }

}
